"use strict";

(function () {
  'use strict';
  /* @ngInject */

  function tripsCtrl(TripService) {
    var vm = this;
  }

  tripsCtrl.$inject = ['TripService'];
  angular.module('view.trips', ['ui.router']).config(['$stateProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state('trips', {
      template: '<trips/>',
      redirectTo: 'trips.list'
    });
    $stateProvider.state('trips.list', {
      parent: 'trips',
      template: '<trips-list/>',
      url: '/trips',
      title: 'Trips'
    });
    $stateProvider.state('trips.detail', {
      parent: 'trips',
      template: '<trips-detail/>',
      url: '/trips/:adminCustDataId/:transactionId',
      title: 'Trip Detail'
    });
  }]).component('trips', {
    bindings: {},
    controller: tripsCtrl,
    templateUrl: 'views/trips/trips.html'
  });
})();